export default __webpack_public_path__ + "static/media/mysql.68c8655e.svg";